import React from 'react';
import { Modal } from './Modal';
import { Button } from './Button';
import { BAR_COUNCIL_DISCLAIMER } from '../../constants/disclaimers';
import { cn } from '../../utils/cn';

interface DisclaimerModalProps {
  isOpen: boolean;
  onAccept: () => void;
  className?: string;
}

export const DisclaimerModal: React.FC<DisclaimerModalProps> = ({
  isOpen,
  onAccept,
  className
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}} // Prevent closing via backdrop or escape
      preventBackdropClose={true}
      preventEscapeClose={true}
      showCloseButton={false}
      size="lg"
      className={cn('max-w-2xl', className)}
      title="Important Legal Disclaimer"
    >
      <div className="space-y-6">
        {/* Disclaimer Content */}
        <div className="prose prose-sm max-w-none">
          <div className="bg-background-light p-4 rounded-lg border border-border-subtle">
            <p className="text-text-dark leading-relaxed whitespace-pre-line text-sm">
              {BAR_COUNCIL_DISCLAIMER}
            </p>
          </div>
        </div>

        {/* Compliance Notice */}
        <div className="bg-primary-navy/5 p-4 rounded-lg border border-primary-navy/20">
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0 mt-1">
              <div className="w-2 h-2 bg-accent-gold rounded-full"></div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-primary-navy mb-1">
                Bar Council of India Compliance
              </h4>
              <p className="text-xs text-text-medium">
                This website complies with Rule 49 of the Bar Council of India Rules. 
                By proceeding, you confirm that you are accessing this information of your own accord.
              </p>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col gap-3 pt-4 border-t border-border-subtle">
          <Button
            onClick={onAccept}
            variant="primary"
            size="lg"
            className="w-full sm:w-auto sm:min-w-[200px]"
          >
            I Understand and Wish to Proceed
          </Button>
          
          <p className="text-xs text-text-light text-center">
            You must acknowledge this disclaimer to access the website content.
          </p>
        </div>

        {/* Additional Legal Notice */}
        <div className="text-xs text-text-light bg-gray-50 p-3 rounded border-l-4 border-accent-gold">
          <p className="font-medium mb-1">Legal Notice:</p>
          <p>
            The information on this website does not constitute legal advice. 
            For specific legal matters, please consult with a qualified attorney.
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default DisclaimerModal;